module.exports = __webpack_public_path__ + "6a6f5f8e1a20a3074803f6ced6a5bd30.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/hand/credit-card-s.png
// module id = 2508
// module chunks = 0